"use strict";

var accounting = require('accounting');
function helper(Handlebars) {
  /**
   * Format number with given operation and options.
   *
   * Defaults:
   * {{percentageFormat xxxx precision='2' format='%v%s'}}
   *
   * {{percentageFormat 0.123 }} = 12.30%
   * {{percentageFormat 0.123 format='%v %s'}} = 12.30 %
   * {{percentageFormat 0.123 precision='0'}} = 12%
   * {{percentageFormat 0.123 precision='0'}} = 13%
   * {{percentageFormat 2.43 precision='2' isPercentage='true'}} = 2.43%
   * {{percentageFormat '' emptySymbol = '--'}} = --
   * {{percentageFormat null emptySymbol = '--' }} = --
   * {{percentageFormat 'dd' }} = dd
   *
   * Beware:
   * {{percentageFormat 12.3 format='%s %v'}} = % 12.30
   *
   * @return {String} formatted String that represents percentage.
   */
  function percentageFormat(n, options) {
    var num = n;
    var opts = options || {
      hash: {}
    };
    var precision = opts.hash.precision || 2;
    var format = opts.hash.format || '%v%s';
    var emptySymbol = opts.hash.emptySymbol || num;
    var isPercentage = opts.hash.isPercentage || 'false';
    var symbol = '%';
    if (typeof num !== 'number') {
      num = parseFloat(num);

      // eslint-disable-next-line no-restricted-globals
      if (isNaN(num)) {
        return emptySymbol;
      }
    }
    if (isPercentage === 'false') {
      num *= 100;
    }
    return accounting.formatMoney(num, {
      symbol: symbol,
      precision: precision,
      format: format
    });
  }
  Handlebars.registerHelper('percentageFormat', percentageFormat);
  return percentageFormat;
}
module.exports = helper;
